import React, { FC } from "react";
import classnames from "classnames";
import ReactTextareaAutoSize, { TextareaAutosizeProps as ReactTextareaAutoSizeProps } from "react-textarea-autosize";

import "./index.scss";

export type TextareaAutoSizeProps = ReactTextareaAutoSizeProps & {
  className?: string;
};

export const TextareaAutoSize: FC<TextareaAutoSizeProps> = ({ className, ...props }) => {
  return (
    <div className={classnames("textarea-wrapper", className)}>
      <ReactTextareaAutoSize {...props} />
    </div>
  );
};
